<div id="app" class="app app-content-full-height app-without-sidebar app-without-header">
  <div id="content" class="app-content p-0">
    <div class="pos pos-vertical pos-with-header pos-with-sidebar pos-mobile-sidebar-toggled" id="pos">
      <div class="pos-container">
        <app-header></app-header>

        <ng-container *ngIf="!isMobile">
          <div class="d-flex justify-content-between align-items-center px-2 mt-2">
            <input
              #searchRef
              type="text"
              name=""
              id=""
              placeholder="Search menu.."
              class="w-100 p-2 px-4 rounded me-3"
              style="border: 1px solid var(--bs-border-color)"
              (input)="searchMenu($event.target.value)" />
            <button class="btn" (click)="searchRef.value = ''; searchMenu('')">
              <i class="fa fa-times-circle"></i>
            </button>

          </div>

          <div class="d-flex" style="height: 100vh;">
            <!-- Sidebar for Category List -->
            <div class="category-sidebar p-2 me-3" style="width: 150px; border-right: 1px solid var(--bs-border-color); overflow-y: auto;">
              <div class="d-flex flex-column h-100">
                <button *ngIf="allowOpenItem" type="button" class="btn btn-warning d-flex justify-content-center align-items-center mb-4 text-center" (click)="openItem()">
                  Open Item
                </button>

                <button class="btn btn-default mb-2 category w-100 py-2"
                        [ngClass]="{active: item.id === selectedCategory.id}"
                        *ngFor="let item of posCategories"
                        (click)="changeCategory(item.id)">
                  {{ item.name }}
                </button>
                <button class="btn btn-light border-0 rounded py-2 mt-auto" (click)="refreshMenu()" style="margin-bottom: 100px">
                  <i class="fa fa-sync"></i> Refresh
                </button>

                <div>&nbsp;</div>
                <div>&nbsp;</div>
                <div>&nbsp;</div>
                <div>&nbsp;</div>
                <div>&nbsp;</div>
                <div>&nbsp;</div>
              </div>
            </div>

            <!-- Main Content -->
            <div class="pos-content flex-grow-1" style="overflow-y: auto;">
              <div class="pos-content-container h-100" style="padding-top: 0 !important;">
                <div class="d-flex flex-wrap gx-4 mt-2 thin-scroll-container">
                  <div
                    class="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 pb-2"
                    data-type="snacks"
                    *ngFor="let item of filteredPosItems"
                    (click)="addItem(item)">
                    <div class="pos-product"
                         matRipple
                         [matRippleCentered]="true"
                         [matRippleColor]="'rgba(255,194,4,0.53)'">
                      <img
                        class="img"
                        loading="lazy"
                        *ngIf="item.posItem?.imageUrl"
                        [ngStyle]="{'background-image': 'url(' + item.posItem.imageUrl + ')'}" />
                      <div class="img justify-content-center align-items-center d-flex" *ngIf="!item.posItem?.imageUrl">
                        <img src="assets/img/no-img.jpg" alt="" class="h-120px">
                      </div>
                      <div class="bg-opacity-70 bg-gray-900 top-0 end-0 h-50px info position-absolute w-35 z-3"
                           style="border-bottom-left-radius: 10px; display: flex; align-items: center;">
                        <div class="text-end" style="color: #ffc400">RM {{ item?.price | number : "1.2" }}</div>
                      </div>

                      <div class="bg-opacity-70 bg-gray-900 bottom-0 h-50px info position-absolute w-100 z-3">
                        <div class="opacity-0">{{ item.posItem.name }}</div>
                      </div>
                      <div class="info position-absolute bottom-0 h-50px p-1 text-center w-100 justify-content-center z-3">
                        <div class="text-white">{{ item.posItem.name }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="pos-sidebar" id="pos-sidebar">
            <div class="h-100 d-flex flex-column p-0">
              <div class="pos-sidebar-header d-flex flex-column justify-content-start w-100">
                <div class="w-100 d-flex flex-row py-1">
                  <div class="back-btn">
                    <button (click)="returnCheckoutPage()"
                      type="button"
                      data-toggle-class="pos-mobile-sidebar-toggled"
                      data-toggle-target="#pos"
                      class="btn">
                      <i class="fa fa-chevron-left"></i>
                    </button>
                  </div>
                  <div class="icon"><i class="fa fa-table"></i></div>
                  <div class="title">Table {{ table?.name }}</div>
                </div>

                <div class="order d-flex flex-row justify-content-between w-100 py-2 mb-2">
                  <div class="d-flex align-items-center">
                    Order No: <span class="fw-semibold">#{{ order?.orderNo }}</span>
                  </div>
                </div>

                <div class="order d-flex flex-row justify-content-between w-100 py-2 mb-2" *ngIf="isTrackPax" (click)="getNoPax(true)">
                  <div class="d-flex align-items-center">
                    <div class=""><i class="fa fa-users me-2" aria-hidden="true"></i> No of Pax: {{ order?.paxNo ? order?.paxNo : 0 }}</div>
                  </div>
                </div>

                <!-- Customer Info -->
                <div class="order d-flex flex-row justify-content-between w-100 py-2" *ngIf="isMembershipSettingExist">
                  <div class="d-flex align-items-center" *ngIf="order?.membership">
                    <div class="symbol-circle me-2">{{ order?.membership?.name?.charAt(0).toUpperCase() }}</div>
                    <div class="membership-details d-flex flex-column me-3">
                      <span class="membership-name">{{ order?.membership?.name }}</span>
                      <span class="membership-phone">{{ order?.membership?.phoneNo }}</span>
                    </div>
                  </div>

                  <button class="btn btn-outline-danger d-flex align-items-center" (click)="removeCustomer()" *ngIf="order?.membership">
                    <i class="fa fa-trash me-2"></i>
                    <span>Remove</span>
                  </button>

                  <ng-container *ngIf="!order?.membership">
                    <button class="btn btn-outline-default d-flex align-items-center" (click)="searchCustomer()">
                      <i class="fa fa-user-plus me-2"></i>
                      <span>Add Customer</span>
                    </button>
                  </ng-container>
                </div>
              </div>

              <div class="pos-sidebar-body" style="height: 100%; overflow: hidden; display: flex; flex-direction: column;">

                <!-- Bootstrap Tab Navigation with Centered and Equal-Sized Tabs -->
                <div class="tab-header" style="flex-shrink: 0;">
                  <ul class="nav nav-tabs justify-content-center" role="tablist" style="display: flex; width: 100%;">
                    <li class="nav-item" style="flex: 1; text-align: center;">
                      <a class="nav-link" [class.active]="activeTab === OrderTypeEnum.DineIn" role="tab" (click)="setActiveTab(OrderTypeEnum.DineIn)" style="width: 100%;">
                        Dine In
                        <span class="badge rounded-pill ms-2" [ngClass]="{'bg-danger': activeTab === OrderTypeEnum.DineIn, 'bg-secondary': activeTab !== OrderTypeEnum.DineIn}">
                          {{ getItemCount(OrderTypeEnum.DineIn) }}
                        </span>
                      </a>
                    </li>
                    <li class="nav-item" style="flex: 1; text-align: center;">
                      <a class="nav-link" [class.active]="activeTab === OrderTypeEnum.TakeAway" role="tab" (click)="setActiveTab(OrderTypeEnum.TakeAway)" style="width: 100%;">
                        Take Away
                        <span class="badge rounded-pill ms-2" [ngClass]="{'bg-danger': activeTab === OrderTypeEnum.TakeAway, 'bg-secondary': activeTab !== OrderTypeEnum.TakeAway}">
                          {{ getItemCount(OrderTypeEnum.TakeAway) }}
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>

                <!-- Scrollable Content Area -->
                <div class="tab-content flex-grow-1 thin-scroll-container" style="overflow-y: auto; height: 100%;">
                  <div class="tab-pane fade show active h-100">
                    <ng-container *ngFor="let item of getFilteredItems(); let i = index">
                      <div class="pos-order">
                        <div class="pos-order-product">
                          <div class="flex-1">
                            <div class="fs-16px fw-bold mb-1">{{ item.name }}</div>
                            <div class="d-flex justify-content-start align-items-center">
                              <div class="fs-16px text-blue-700 me-3" role="button" (click)="editItem(item)">
                                <i class="fa fa-edit"></i> Edit Item
                              </div>
                              <div class="fs-16px text-blue-700" role="button" (click)="editDiscount(item)">
                                <i class="fa fa-percentage"></i> Discount
                              </div>
                            </div>
                            <div class="fs-12px mb-1" *ngIf="item.instructions">
                              "<span class="fst-italic">{{ item.instructions }}"</span>
                            </div>
                            <div class="mb-2 mt-2">
                              <ng-container *ngFor="let variant of item.varianceModel">
                  <span *ngIf="variant?.options?.length > 0">
                    - {{ variant.title }}
                    <ul class="mb-0">
                      <ng-container *ngFor="let variantOption of variant.options">
                        <span class="d-inline-block" style="min-width: 150px; max-width: 200px">
                          {{ variantOption.name }}
                        </span>
                        <span>+RM{{ variantOption.price | number : "1.2" }}</span>
                      </ng-container>
                    </ul>
                  </span>
                              </ng-container>
                            </div>
                            <div class="d-flex align-items-center">
                              <button class="btn btn-primary btn-sm" (click)="minusQty(item)">
                                <i class="fa fa-minus"></i>
                              </button>
                              <span class="w-25 text-center"> {{ item?.quantity }}</span>
                              <button class="btn btn-primary btn-sm" (click)="addQty(item)">
                                <i class="fa fa-plus"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                        <div class="pos-order-price d-flex flex-column">
                          <div *ngIf="item.discountAmount > 0" class="flex-1 text-right fs-16px">
                            RM {{ item.subtotal - item.discountAmount | number : "1.2" }}
                          </div>
                          <div class="flex-1 text-right fs-16px"
                               [class.text-gray-500]="item.discountAmount > 0 ? 'line-through': ''"
                               [class.small]="item.discountAmount > 0 ? 'line-through': ''"
                               [style.text-decoration]="item.discountAmount > 0 ? 'line-through': ''">
                            <span>RM {{ item.subtotal | number : "1.2" }}</span>
                            <span class="ms-1" *ngIf="item?.discountAmount >0">({{ item?.discountPercentage }}%)</span>
                          </div>
                          <div class="text-end">
                            <button class="btn btn-default btn-sm border-0" (click)="item['isRemoved'] = true">
                              <i class="fa fa-trash text-danger"></i>
                            </button>
                          </div>
                        </div>
                        <div class="pos-order-confirmation text-center d-flex flex-column justify-content-center" *ngIf="item['isRemoved']">
                          <div class="mb-1">
                            <i class="fa fa-trash fs-36px lh-1 text-body text-opacity-25"></i>
                          </div>
                          <div class="mb-2">Remove {{ item.name }}?</div>
                          <div>
                            <button class="btn btn-default btn-sm ms-auto me-4 width-100px" (click)="item['isRemoved'] = false">No</button>
                            <button class="btn btn-danger btn-sm width-100px" (click)="removeItem(i)">Yes</button>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>

              </div>


              <div class="pos-sidebar-footer">
                <mat-accordion>
                  <mat-expansion-panel hideToggle>
                    <mat-expansion-panel-header class="px-3">
                      <div class="d-flex w-100 justify-content-between fs-18px fw-semibold">
                        <span>Qty</span>
                        <span class="text-right">{{ orderQuantity }}</span>
                        <span>Grand Total</span>
                        <span class="text-right">{{ order?.netAmount | number: "1.2" }}</span>
                      </div>
                    </mat-expansion-panel-header>
                    <dl class="space-y-1 py-2 text-sm text-gray-700">

                      <ng-container *ngIf="order?.inclusiveTax > 0">
                        <div class="d-flex justify-content-between" style="font-style: italic">
                          <dd>(Inclusive of 6% SST: RM{{ order?.inclusiveTax | number: "1.2" }})</dd>
                        </div>
                      </ng-container>

                      <div class="d-flex justify-content-between">
                        <dt>Subtotal</dt>
                        <dd>{{ order?.subtotal | number: "1.2" }}</dd>
                      </div>

                      <ng-container *ngIf="order?.tax1Amount > 0">
                      <div class="d-flex justify-content-between">
                        <dt>SST</dt>
                        <dd>{{ order?.tax1Amount | number: "1.2" }}</dd>
                      </div>
                      </ng-container>

                      <div class="d-flex justify-content-between" *ngIf="order?.tax2Amount > 0">
                        <dt>Serv Charge</dt>
                        <dd>{{ order?.tax2Amount | number: "1.2" }}</dd>
                      </div>

                      <div class="d-flex justify-content-between">
                        <dt>Item Discount</dt>
                        <dd>
                          -{{
                            order?.discountItemAmount | number: "1.2"
                          }}
                        </dd>
                      </div>

                      <div class="d-flex justify-content-between">
                        <dt>Rounding</dt>
                        <dd>
                          {{ order?.roundingAmount | number: "1.2" }}
                        </dd>
                      </div>
                    </dl>
                  </mat-expansion-panel>
                </mat-accordion>

                <div class="mt-3">
                  <div class="d-flex">
                    <button
                      class="btn btn-default text-danger border-0 me-10px flex-fill d-flex align-items-center justify-content-center"
                      (click)="clearCart()"
                      *ngIf="order?.id == 0"
                      [disabled]="order?.orderItems?.length == 0 || loading.holding">
                    <span class="d-flex flex-column align-items-center">
                      <i class="fa fa-trash fa-lg my-10px d-block"></i>
                      <span class="small fw-semibold">Clear</span>
                    </span>
                    </button>
                    <button
                      class="btn btn-default bg-secondary text-white border-0 me-10px flex-fill d-flex align-items-center justify-content-center"
                      (click)="hold()"
                      *ngIf="order?.id == 0"
                      [disabled]="order?.orderItems?.length == 0 || loading.holding">
                    <span class="d-flex flex-column align-items-center">
                      <i class="fa fa-shopping-cart fa-lg my-10px d-block"></i>
                      <span class="small fw-semibold">Hold</span>
                    </span>
                    </button>
                    <button
                      class="btn btn-default bg-primary text-white flex-fill d-flex align-items-center justify-content-center"
                      (click)="submitOrder()"
                      [disabled]="order?.orderItems?.length == 0 || loading.submitting">
                    <span class="d-flex flex-column align-items-center">
                      <i class="fa fa-cash-register fa-lg my-10px d-block"></i>
                      <span class="small fw-semibold">{{ order?.id > 0 ? 'Update Order' : 'Submit Order' }}</span>
                    </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isMobile">

          <div class="d-flex justify-content-between align-items-center px-2 mt-2">
            <input
              #searchRef
              type="text"
              name=""
              id=""
              placeholder="Search menu.."
              class="w-100 p-2 px-4 rounded me-3"
              style="border: 1px solid var(--bs-border-color)"
              (input)="searchMenu($event.target.value)" />
            <button class="btn" (click)="searchRef.value = ''; searchMenu('')">
              <i class="fa fa-times-circle"></i>
            </button>
          </div>

          <div class="d-flex justify-content-between align-items-start py-2 px-2">
            <div class="h-100 ps w-100    me-3" data-scrollbar="true" data-skip-mobile="true">
              <div class="d-flex flex-row overflow-auto" style="white-space: nowrap">
                <button *ngIf="allowOpenItem" type="button" class="btn btn-warning me-2 category w-auto h-50px py-2" style="width: 150px; height: 50px" (click)="openItem()">
                  Open Item
                </button>
                <button class="btn btn-default me-2 category w-auto h-50px py-2"
                        [ngClass]="{active: item.id === selectedCategory.id}"
                        *ngFor="let item of posCategories"
                        (click)="changeCategory(item.id)">
                  {{ item.name }}
                </button>
              </div>

            </div>

            <button class="h-100  border-0 rounded btn small py-2"
                    (click)="refreshMenu()"><i class="fa fa-sync"></i>
            </button>
          </div>

          <div class="pos-content overflow-y-auto thin-scroll-container" *ngIf="!isCheckout" style="">
            <div class="pos-content-container h-100" style="padding-top: 0 !important;">
              <div class="d-flex flex-wrap gx-2 mt-2 thin-scroll-container">
                <div
                  class="col-6 col-md-4 p-1"
                  data-type="snacks"
                  *ngFor="let item of filteredPosItems"
                  (click)="openOrderTypeDialog(item)">
                  <div class="pos-product position-relative" matRipple [matRippleCentered]="true" [matRippleColor]="'rgba(255,194,4,0.53)'">
                    <div class="img-container d-flex justify-content-center align-items-center w-100 h-120px">
                      <img
                        class="img-fluid w-100 h-100"
                        loading="lazy"
                        *ngIf="item.posItem?.imageUrl"
                        [src]="item.posItem.imageUrl"
                        alt="{{ item.posItem.name }}" />
                      <img
                        src="assets/img/no-img.jpg"
                        alt="No Image"
                        class="img-fluid w-100 h-100"
                        *ngIf="!item.posItem?.imageUrl">
                    </div>
                    <div class="bg-opacity-70 bg-gray-900 top-0 end-0 h-50px info position-absolute w-35 z-3"
                         style="border-bottom-left-radius: 10px; display: flex; align-items: center;">
                      <div class="text-end" style="color: #ffc400">RM {{ item?.price | number : "1.2" }}</div>
                    </div>
                    <div class="bg-opacity-70 bg-gray-900 bottom-0 h-50px info position-absolute w-100 z-3">
                      <div class="opacity-0">{{ item.posItem.name }}</div>
                    </div>
                    <div class="info position-absolute bottom-0 h-50px p-1 text-center w-100 justify-content-center z-3">
                      <div class="text-white">{{ item.posItem.name }}</div>
                    </div>
                    <div class="quantity-badge position-absolute top-0 start-0 m-1 bg-warning text-white rounded-circle d-flex align-items-center justify-content-center" *ngIf="getQuantity(item) > 0">
                      {{ getQuantity(item) }}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="pos-sidebar" id="pos-sidebar" *ngIf="isCheckout" style="z-index: 1">
            <div class="h-100 d-flex flex-column p-0">
              <div class="pos-sidebar-header d-flex flex-column justify-content-start w-100 pt-3">
                <div class="w-100 d-flex flex-row py-1 mt-5">
                  <div class="back-btn">
                    <button (click)="returnCheckoutPage()"
                      type="button"
                      data-toggle-class="pos-mobile-sidebar-toggled"
                      data-toggle-target="#pos"
                      class="btn">
                      <i class="fa fa-chevron-left" ></i>
                    </button>
                  </div>
                  <div class="icon mt-2"><i class="fa fa-table"></i></div>
                  <div class="title mt-2">Table {{ table?.name }}</div>
                  <div class="order">
                    Order No: <span class="fw-semibold">#{{ order?.orderNo }}</span>
                  </div>
                </div>

                <div class="order d-flex flex-row justify-content-between w-100 pt-3 pb-3 mb-2" *ngIf="isTrackPax" (click)="getNoPax(true)">
                  <div class="d-flex align-items-center">
                    <div class=""><i class="fa fa-users me-2" aria-hidden="true"></i> No of Pax: {{ order?.paxNo }}</div>
                  </div>
                </div>
                <!--              customer info -->
                <div class="order d-flex flex-row justify-content-start w-100 pt-3 pb-3">
                  <div class="d-flex align-items-center mt-2 mb-1" *ngIf="order?.membership">
                    <i class="fa fa-user-circle text-primary me-2" style="font-size: 1.5rem;"></i>
                    <div class="d-flex flex-column flex-grow-1 me-3">
    <span class="text-start text-primary fw-bold">
      {{ order?.membership?.name }} ({{ order?.membership?.phoneNo }})
    </span>
                    </div>
                    <button class="btn btn-light border-0 p-0" (click)="removeCustomer()">
                      <i class="fa fa-trash text-danger"></i>
                    </button>
                  </div>
                  <ng-container *ngIf="!order?.membership">
                    <button
                      class="btn btn-default border-0"
                      (click)="searchCustomer()">
                      <span class="me-2">Add customer</span>
                      <i class="fa fa-user-plus"></i>
                    </button>
                  </ng-container>
                </div>

              </div>
              <!-- Bootstrap Tab Navigation with Centered and Equal-Sized Tabs -->
              <div class="tab-header" style="flex-shrink: 0;">
                <ul class="nav nav-tabs justify-content-center" role="tablist" style="display: flex; width: 100%;">
                  <li class="nav-item" style="flex: 1; text-align: center;">
                    <a class="nav-link" [class.active]="activeTab === OrderTypeEnum.DineIn" role="tab" (click)="setActiveTab(OrderTypeEnum.DineIn)" style="width: 100%;">
                      Dine In
                      <span class="badge rounded-pill ms-2" [ngClass]="{'bg-danger': activeTab === OrderTypeEnum.DineIn, 'bg-secondary': activeTab !== OrderTypeEnum.DineIn}">
                          {{ getItemCount(OrderTypeEnum.DineIn) }}
                        </span>
                    </a>
                  </li>
                  <li class="nav-item" style="flex: 1; text-align: center;">
                    <a class="nav-link" [class.active]="activeTab === OrderTypeEnum.TakeAway" role="tab" (click)="setActiveTab(OrderTypeEnum.TakeAway)" style="width: 100%;">
                      Take Away
                      <span class="badge rounded-pill ms-2" [ngClass]="{'bg-danger': activeTab === OrderTypeEnum.TakeAway, 'bg-secondary': activeTab !== OrderTypeEnum.TakeAway}">
                          {{ getItemCount(OrderTypeEnum.TakeAway) }}
                        </span>
                    </a>
                  </li>
                </ul>
              </div>

              <div
                class="pos-sidebar-body thin-scroll-container tab-content"
                data-scrollbar="true"
                data-height="100%"
                style="height: 100%">
                <div class="tab-pane fade h-100 show active" id="newOrderTab" role="tabpanel">
                  <ng-container *ngFor="let item of getFilteredItems(); let i = index">
                    <div class="pos-order">
                      <div class="pos-order-product">
                        <div class="flex-1">
                          <div class="fs-16px fw-bold mb-1">{{ item.name }}</div>
                          <div class="d-flex justify-content-start align-items-center">
                            <div class="fs-16px text-blue-700 me-3" role="button" (click)="editItem(item)">
                              <i class="fa fa-edit"></i>
                              Edit Item
                            </div>
                            <div class="fs-16px text-blue-700" role="button" (click)="editDiscount(item)">
                              <i class="fa fa-percentage"></i>
                              Discount
                            </div>
                          </div>

                          <div class="fs-12px mb-1" *ngIf="item.instructions">"<span
                            class="fst-italic">{{ item.instructions }}"</span></div>

                          <div class="mb-2 mt-2">
                            <ng-container *ngFor="let variant of item.varianceModel">
                            <span *ngIf="variant?.options?.length > 0">
                              - {{ variant.title }}
                              <ul class="mb-0">
                                <ng-container *ngFor="let variantOption of variant.options">
                                  <span class="d-inline-block" style="min-width: 150px; max-width: 200px">
                                    {{ variantOption.name }}
                                  </span>
                                  <span>
                                    +RM{{ variantOption.price | number : "1.2" }}
                                  </span>
                                </ng-container>
                              </ul>
                            </span>
                            </ng-container>
                            <!--                          - size: large<br>-->
                            <!--                          - less ice-->
                          </div>
                          <div class="d-flex align-items-center">
                            <button class="btn btn-primary btn-sm" (click)="minusQty(item)">
                              <i class="fa fa-minus"></i>
                            </button>
                            <!--                          <input-->
                            <!--                            type="text"-->
                            <!--                            class="form-control w-50px form-control-sm mx-2 bg-white bg-opacity-25 bg-white bg-opacity-25 text-center"-->
                            <!--                            value="{{ item?.quantity }}" />-->
                            <span class="w-25 text-center"> {{ item?.quantity }}</span>
                            <button class="btn btn-primary btn-sm" (click)="addQty(item)">
                              <i class="fa fa-plus"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="pos-order-price d-flex flex-column">
                        <div *ngIf="item.discountAmount > 0" class="flex-1 text-right fs-16px">
                          RM {{ item.subtotal - item.discountAmount | number : "1.2" }}
                        </div>
                        <div class="flex-1 text-right fs-16px"
                             [class.text-gray-500]="item.discountAmount > 0 ? 'line-through': ''"
                             [class.small]="item.discountAmount > 0 ? 'line-through': ''"
                             [style.text-decoration]="item.discountAmount > 0 ? 'line-through': ''">
                          <span>RM {{ item.subtotal | number : "1.2" }}</span>
                          <span class="ms-1" *ngIf="item?.discountAmount >0">({{ item?.discountPercentage }}%)</span>
                        </div>
                        <div class="text-end">
                          <button class="btn btn-default btn-sm border-0" (click)="item['isRemoved'] = true">
                            <i class="fa fa-trash text-danger"></i>
                          </button>
                        </div>
                      </div>

                      <div
                        class="pos-order-confirmation text-center d-flex flex-column justify-content-center"
                        *ngIf="item['isRemoved']">
                        <div class="mb-1">
                          <i class="fa fa-trash fs-36px lh-1 text-body text-opacity-25"></i>
                        </div>
                        <div class="mb-2">Remove {{ item.name }}?</div>
                        <div>
                          <button
                            class="btn btn-default btn-sm ms-auto me-4 width-100px"
                            (click)="item['isRemoved'] = false">
                            No
                          </button>
                          <button class="btn btn-danger btn-sm width-100px" (click)="removeItem(i)">Yes</button>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div class="pos-sidebar-footer">
                <mat-accordion>
                  <mat-expansion-panel hideToggle>
                    <mat-expansion-panel-header class="px-3">
                      <div class="d-flex w-100 justify-content-between fs-18px fw-semibold">
                        <span>Qty</span>
                        <span class="text-right">{{ orderQuantity }}</span>
                        <span>Grand Total</span>
                        <span class="text-right">{{ order?.netAmount | number: "1.2" }}</span>
                      </div>
                    </mat-expansion-panel-header>
                    <dl class="space-y-1 py-2 text-sm text-gray-700">
                      <ng-container *ngIf="order?.inclusiveTax > 0">
                        <div class="d-flex justify-content-between" style="font-style: italic">
                          <dd>(Inclusive of 6% SST: RM {{ order?.inclusiveTax | number: "1.2" }})</dd>
                        </div>
                      </ng-container>

                      <div class="d-flex justify-content-between">
                        <dt>Subtotal</dt>
                        <dd>{{ order?.subtotal | number: "1.2" }}</dd>
                      </div>

                      <div class="d-flex justify-content-between" *ngIf="order?.tax1Amount > 0">
                        <dt>SST</dt>
                        <dd>{{ order?.tax1Amount | number: "1.2" }}</dd>
                      </div>

                      <div class="d-flex justify-content-between" *ngIf="order?.tax2Amount > 0">
                        <dt>Serv Charge</dt>
                        <dd>{{ order?.tax2Amount | number: "1.2" }}</dd>
                      </div>

                      <div class="d-flex justify-content-between">
                        <dt>Item Discount</dt>
                        <dd>
                          -{{
                            order?.discountItemAmount | number: "1.2"
                          }}
                        </dd>
                      </div>

                      <div class="d-flex justify-content-between">
                        <dt>Rounding</dt>
                        <dd>
                          {{ order?.roundingAmount | number: "1.2" }}
                        </dd>
                      </div>
                    </dl>
                  </mat-expansion-panel>
                </mat-accordion>

                <div class="mt-3">
                  <div class="d-flex">
                    <button
                      class="btn btn-default text-danger border-0 me-10px flex-fill d-flex align-items-center justify-content-center"
                      (click)="clearCart()"
                      *ngIf="order?.id == 0"
                      [disabled]="order?.orderItems?.length == 0 || loading.holding">
                    <span class="d-flex flex-column align-items-center">
                      <i class="fa fa-trash fa-lg my-10px d-block"></i>
                      <span class="small fw-semibold">Clear</span>
                    </span>
                    </button>
                    <button
                      class="btn btn-default bg-secondary text-white border-0 me-10px flex-fill d-flex align-items-center justify-content-center"
                      (click)="hold()"
                      *ngIf="order?.id == 0"
                      [disabled]="order?.orderItems?.length == 0 || loading.holding">
                    <span class="d-flex flex-column align-items-center">
                      <i class="fa fa-shopping-cart fa-lg my-10px d-block"></i>
                      <span class="small fw-semibold">Hold</span>
                    </span>
                    </button>
                    <button
                      class="btn btn-default bg-primary text-white flex-fill d-flex align-items-center justify-content-center"
                      (click)="submitOrder()"
                      [disabled]="order?.orderItems?.length == 0 || loading.submitting">
                    <span class="d-flex flex-column align-items-center">
                      <i class="fa fa-cash-register fa-lg my-10px d-block"></i>
                      <span class="small fw-semibold">{{ order?.id > 0 ? 'Update Order' : 'Submit Order' }}</span>
                    </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <a *ngIf="!isCheckout"
       (click)="checkout($event)"
       class="pos-mobile-sidebar-toggler"
       data-toggle-class="pos-mobile-sidebar-toggled"
       data-toggle-target="#pos">
      <i class="fa fa-shopping-bag"></i>
      <span class="badge">{{ getQuantityAllItem() }}</span>
    </a>
  </div>
</div>
